import React, { useState, useEffect } from 'react';
import { Bell, X, CheckCircle } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { dailyTaskService } from '@/services/dailyTaskService';

export const DailyTaskNotification: React.FC = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [pendingTasks, setPendingTasks] = useState<any[]>([]);

  useEffect(() => {
    const checkPendingTasks = async () => {
      if (!user?.id) return;
      
      try {
        const tasks = await dailyTaskService.getTodaysDailyTasks(user.id);
        const pending = tasks.filter(task => !task.completed);
        
        if (pending.length > 0) {
          setPendingTasks(pending);
          
          // Show notification after 30 seconds if tasks are still pending
          const timer = setTimeout(() => {
            setShow(true);
          }, 30000);
          
          return () => clearTimeout(timer);
        }
      } catch (error) {
        console.error('Error checking pending tasks:', error);
      }
    };

    checkPendingTasks();
    
    // Check every 5 minutes
    const interval = setInterval(checkPendingTasks, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, [user?.id]);

  if (!show || pendingTasks.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 max-w-sm z-50 animate-fade-in">
      <div className="bg-white border-l-4 border-amber-500 shadow-lg rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-start space-x-3">
            <Bell className="w-5 h-5 text-amber-500 mt-0.5 animate-pulse" />
            <div className="flex-1">
              <h4 className="font-semibold text-gray-900 text-sm">
                Daily Task Reminder
              </h4>
              <p className="text-gray-700 text-xs mt-1">
                You have {pendingTasks.length} daily task{pendingTasks.length > 1 ? 's' : ''} pending:
              </p>
              <ul className="mt-2 space-y-1">
                {pendingTasks.map((task) => (
                  <li key={task.id} className="text-xs text-gray-600 flex items-center">
                    <CheckCircle className="w-3 h-3 mr-1 text-gray-400" />
                    {task.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <button
            onClick={() => setShow(false)}
            className="text-gray-400 hover:text-gray-600 ml-2"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};